import { useSelector } from 'react-redux'

import { selectAll } from 'redux/selectors/CredentialsGroups'

export const useCredentialsGroups = () => {
  return useSelector(selectAll)
}
